import "../css/app.scss";
import bookNow from "./components/book-now";

window.addEventListener('load', () => {
    bookNow();
})
